import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import cross from "../assets/img/cross.svg";
import { addTalkingBadge } from "store/actions/talkingBadgeAction";
import { useDispatch, useSelector } from "react-redux";
import TalkingPreview from "./TalkingPreview";
import { toast } from "react-toastify";
import moment from "moment";
import { getVoteGetterBadge } from "store/actions/talkingBadgeAction";
import { deleteTalkingBadge } from "store/actions/talkingBadgeAction";
import VoteGetterEdit from "./VoteGetterEdit";
import ReuseableTable from "./Tables/ReuseableTable";
import firebase from "../config/firebase";
import { addContestVideo } from "store/actions/contestAction";

const VoteGetter = ({
  toggle,
  addModal,
  Id,
  type,
  winnerQrCode,
  activeTab,
  setWinnerQrCode,
  brandAmbassadorData,
}) => {
  const dispatch = useDispatch();
  const { votegetterBadges, singleAmbassodarVideo, isAddLoading } = useSelector(
    (state) => state.talkingBadges
  );

  const { user, uid } = useSelector((state) => state.auth);
  const [qrCodePrice, setqrCodePrice] = useState("");
  const [modal2, setModal2] = useState(false);
  const [editData, setEditData] = useState(null);
  const [formData, setFormData] = useState({
    introducingVideo: null,
    appealingVideo: winnerQrCode ? winnerQrCode : null,
    amount: qrCodePrice,
    athleteId: user.id,
    athleteID: user.athleteID,
    description: "",
    type: type,
  });

  const [showCustomPriceInput, setShowCustomPriceInput] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);

  const toggleModal2 = (item) => {
    setEditData(item);
    setModal2(!modal2);
  };

  const handleImageChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/svg",
      ];
      if (validImageTypes.includes(file.type)) {
        setFormData((prevData) => ({
          ...prevData,
          [fieldName]: file,
        }));
      } else {
        toast.error("Invalid file type. Please select a valid image file.");
      }
    }
  };

  const handleSubmit = async (props) => {
    let NewData = {
      ...formData,
      contestId: Id,
      ...(type === "votegetter" && {
        contestVideoId: singleAmbassodarVideo?.id,
      }),
    };
    if (props.purchaseID) {
      NewData.purchaseID = props.purchaseID;
    }
    if (NewData.amount == "") {
      return toast.warning("Add Badge QR Price");
    }
    if (singleAmbassodarVideo?.id) {
      await dispatch(
        addTalkingBadge(NewData, () => {
          toast.success("Create Badge Sucessfully");
          setqrCodePrice("");
          resetFormData();
          setShowCustomPriceInput(false);
          toggle();
        })
      );
    } else {
      const data1 = {
        contestEnrollmentId: brandAmbassadorData.contestEnrollmentId,
        contest_id: brandAmbassadorData.id,
        videoUrl: [],
        votes: 0,
        participantList: [uid],
        createdAt: firebase.firestore.Timestamp.now(),
        athleteId: uid,
      };
      dispatch(
        addContestVideo(data1, (res) => {
          let NewData2 = {
            ...formData,
            contestId: Id,
            ...(type === "votegetter" && {
              contestVideoId: res,
            }),
          };
          dispatch(
            addTalkingBadge(NewData2, () => {
              toast.success("Create Badge Sucessfully");
              setqrCodePrice("");
              resetFormData();
              setShowCustomPriceInput(false);
              toggle();
            })
          );
        })
      );
    }
  };

  const resetFormData = () => {
    setqrCodePrice("");
    setFormData({
      introducingVideo: null,
      appealingVideo: null,
      amount: qrCodePrice,
      athleteId: user.id,
      athleteID: user.athleteID,
      description: "",
      type: type,
    });
  };

  const deleteBadge = async (id, IntroducingImage, AppealingVideo) => {
    await dispatch(
      deleteTalkingBadge(id, IntroducingImage, AppealingVideo, () => {
        toast.success("Badge Deleted Sucessfully");
      })
    );
  };

  const data = {
    athleteImg: user?.player_image?.url,
    firstName: user?.first_name,
    lastName: user?.last_name,
    introducingVideo: formData.introducingVideo,
    appealingVideo: formData.appealingVideo,
    description: formData.description,
  };

  const columns = [
    "CreatedAt",
    "Amount",
    "Introducing Image",
    "Appealing Video",
  ];

  const keyMap = {
    CreatedAt: "createdAt",
    Amount: "amount",
    "Introducing Image": "introducingVideo",
    "Appealing Video": "appealingVideo",
  };

  const renderActions = (item) => {
    return (
      <Button
        size="sm"
        color="danger"
        disabled={true}
        onClick={() =>
          deleteBadge(item.id, item?.IntroducingImage, item?.AppealingVideo)
        }
      >
        Delete
      </Button>
    );
  };

  useEffect(() => {
    setTableLoader(true);
    let obj = {
      athleteId: uid,
      contestId: Id,
    };
    dispatch(
      getVoteGetterBadge(obj, () => {
        setTableLoader(false);
      })
    );
  }, [Id]);

  useEffect(() => {
    resetFormData();
  }, [addModal]);

  return (
    <Modal isOpen={addModal} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Create{" "}
        {activeTab == "sportContest"
          ? "Sport Contest Badges"
          : activeTab == "brandAmbassadorContest"
          ? "Brand Ambassador Badge"
          : "Talking Badge"}
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={(e) => {
            if (singleAmbassodarVideo?.voteGetterBadge >= 5) {
              e.preventDefault();
              toast.error("Only add 5 badges");
            } else {
              e.preventDefault();
              handleSubmit(e);
            }
          }}
        >
          <Row className="d-flex justify-content-center">
            <Col className="col-sm-6 col-6">
              <FormGroup className="d-flex flex-column">
                <Label for="appealingVideo">Add Description</Label>
                <Input
                  required
                  id="appealingVideo"
                  name="description"
                  type="text"
                  placeholder="Enter Description"
                  value={formData.description}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue.length <= 20) {
                      setFormData((prevData) => ({
                        ...prevData,
                        description: inputValue,
                      }));
                    } else {
                      toast.error("Only 20 characters are allowed");
                    }
                  }}
                />
              </FormGroup>
            </Col>
            <Col className="col-sm-6 col-6">
              <FormGroup>
                <Label for="exampleSelect">Online Badge Card Price</Label>
                <Input
                  id="exampleSelect"
                  name="select"
                  type="select"
                  value={qrCodePrice}
                  onChange={(e) => {
                    setqrCodePrice(e.target.value);
                    setFormData((prevData) => ({
                      ...prevData,
                      amount: e.target.value,
                    }));
                    if (e.target.value === "custom") {
                      setShowCustomPriceInput(true);
                    } else {
                      setShowCustomPriceInput(false);
                    }
                  }}
                >
                  <option value="">--Select Price--</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="40">40</option>
                  <option value="custom">Custom Value</option>
                </Input>
                {showCustomPriceInput && (
                  <Input
                    required
                    className="mt-2"
                    type="number"
                    placeholder="Enter Custom Value"
                    value={qrCodePrice}
                    onChange={(e) => {
                      setqrCodePrice(e.target.value);
                      setFormData((prevData) => ({
                        ...prevData,
                        amount: e.target.value,
                      }));
                    }}
                    min={17}
                    max={1000}
                  />
                )}
              </FormGroup>{" "}
            </Col>

            <Col className="col-sm-6 col-6">
              <FormGroup className="d-flex flex-column">
                <Label for="introducingVideo">
                  QR Code introduce self Video
                </Label>
                {formData.introducingVideo && (
                  <div className="position-relative">
                    <img
                      src={URL.createObjectURL(formData.introducingVideo)}
                      alt=""
                      className="mb-3"
                      width={80}
                      height={80}
                      required
                    />
                    <img
                      src={cross}
                      width={20}
                      alt=""
                      className="position-absolute"
                      required
                      style={{
                        top: "-11%",
                        left: "22%",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setFormData((prevData) => ({
                          ...prevData,
                          introducingVideo: null,
                        }))
                      }
                    />
                  </div>
                )}
                {!formData.introducingVideo && (
                  <Input
                    id="introducingVideo"
                    name="introducingVideo"
                    type="file"
                    accept=".jpg, .jpeg, .svg, .png"
                    onChange={(e) => handleImageChange(e, "introducingVideo")}
                    required
                  />
                )}
              </FormGroup>
            </Col>

            <Col className="col-sm-6 col-6">
              <FormGroup className="d-flex flex-column">
                <Label for="appealingVideo">QR Code entertainment Video</Label>
                {(formData.appealingVideo || winnerQrCode) && (
                  <div className="position-relative">
                    <img
                      src={
                        winnerQrCode
                          ? winnerQrCode
                          : URL?.createObjectURL(formData?.appealingVideo)
                      }
                      alt=""
                      className="mb-3"
                      width={80}
                      height={80}
                      required
                    />
                    {!winnerQrCode && (
                      <img
                        src={cross}
                        width={20}
                        alt=""
                        className="position-absolute"
                        required
                        style={{
                          top: "-11%",
                          left: "22%",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setFormData((prevData) => ({
                            ...prevData,
                            appealingVideo: null,
                          }))
                        }
                      />
                    )}
                  </div>
                )}
                {(!formData.appealingVideo || !winnerQrCode) && (
                  <Input
                    required
                    id="appealingVideo"
                    name="appealingVideo"
                    type="file"
                    accept=".jpg, .jpeg, .svg, .png"
                    onChange={(e) => handleImageChange(e, "appealingVideo")}
                  />
                )}
              </FormGroup>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Button color="primary" type="submit">
              {isAddLoading ? <Spinner size={"sm"} /> : "Create Badge"}
            </Button>
          </Row>
        </Form>
        <Row className="d-flex justify-content-center">
          <Card className="col-lg-6 col-md-8 col-sm-8 mb-3 mt-5 mx-2">
            <TalkingPreview data={data} />
          </Card>
        </Row>
        <Card>
          {tableLoader && (
            <Row className="justify-content-center my-4">
              <Spinner size="sm" />
            </Row>
          )}
          {!tableLoader && (
            <ReuseableTable
              columns={columns}
              data={votegetterBadges?.map((item) => ({
                ...item,
                createdAt: moment
                  .unix(item?.createdAt?.seconds)
                  .format("D MMM YYYY"),
                amount: item?.amount,
                introducingVideo: (
                  <img
                    src={item.introducingImageUrl}
                    className="cursor-pointer"
                    width={"50px"}
                  />
                ),
                appealingVideo: (
                  <img
                    src={item.appealingVideoUrl}
                    className="cursor-pointer"
                    width={"50px"}
                  />
                ),
              }))}
              keyMap={keyMap}
              renderActions={renderActions}
            />
          )}
        </Card>
      </ModalBody>
      <VoteGetterEdit
        toggle={toggleModal2}
        addModal={modal2}
        editData={editData}
      />
    </Modal>
  );
};

export default VoteGetter;
